<template>
  <div class="statis-student-overview">
    <div class="title">概览</div>
    <div class="overview-total">
      <div class="overview-box">
          <div>总交易额</div>
          <div class="tips">上线至今</div>
          <div class="number">{{total.sum_total/100}}元</div>
      </div>
      <div class="overview-box">
        <div>总订单量</div>
        <div class="tips">上线至今</div>
        <div class="number">{{total.total}}笔</div>
      </div>
      <div class="overview-box">
        <div>下单人数</div>
        <div class="tips">上线至今</div>
        <div class="number">{{total.user_total}}人</div>
      </div>
    </div>
    <div class="overview-line">
      <Form :model="searchCondition" :label-width="70" inline>
        <FormItem label="日期范围">
          <DatePicker
            ref="formDate"
            type="daterange"
            placeholder="选择日期范围"
            @on-change="onDateChange"
            style="width:200px;"
            :editable="false"
            v-model="dateRange"
            clearable
          ></DatePicker>
        </FormItem>
        <FormItem class="search-form-btns">
          <div class="btn-wrap form-item-search">
            <Button icon="ios-search" @click="onSearch">搜索</Button>
            <Button icon="md-undo" @click="onReset">重置</Button>
          </div>
        </FormItem>
      </Form>

      <div>
          <span class="new-price-increase">总交易额：{{searchPriceTotal/100}}元</span>
          <span class="new-count-increase">总订单量:{{searchTotal}}笔</span>
          <span class="new-user-increase">下单人数:{{searchUserTotal}}人</span>
      </div>

      <div class="container">
        <chart :options="orgOptions" :auto-resize="true"></chart>
      </div>
    </div>
  </div>
</template>

<script>
import { CouseType } from "@/utils/enums";
import 'echarts/lib/chart/line'
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

export default {
  name: "OrderOverview",
  data() {
    return {
      orgOptions: {},
      searchCondition: {
        start: '',
        end: ''
      },
      total: {
        total: 0,
        sum_total: 0,
        user_total: 0
      },
      searchTotal: 0,
      searchPriceTotal: 0,
      searchUserTotal: 0,
      dateRange: []
    };
  },
  created() {
    this.requestTotal();
    this.requsetLine()
  },
  methods: {
    onSearch() {
      this.requsetLine();
    },
    onReset() {
      this.dateRange = [];
      this.searchCondition.start = '';
      this.searchCondition.end = '';
      this.requsetLine();
    },
    onDateChange(date) {
      this.searchCondition.start = parseInt(new Date(date[0]).getTime() / 1000);
      this.searchCondition.end = parseInt(new Date(date[1]).getTime() / 1000);
    },
    requestTotal()
    {
      this.$http.post('/api/order/statics/total').then(res=>{
        this.total = res
      })
    },
    requsetLine() {
      let _this = this;
      this.$http.post('/api/order/statics/line',this.searchCondition).then(res=>{
        this.orgOptions = {
          tooltip: {
              trigger: 'axis',
              show: true
          },
          xAxis: {
              type: 'category',
              data: res.line.date
          },
          yAxis: {
              type: 'value'
          },
          series: [{
              name:'总订单量',
              data: res.line.count,
              type: 'line'
          },{
              name:'总交易额',
              data: res.line.sum,
              type: 'line',
          },{
              name:'下单人数',
              data: res.line.user,
              type: 'line',
          }],
          legend: {
              data: ['总订单量', '总交易额','下单人数'],
          },
          width:800,
          height: 250,
        };
        _this.searchTotal = res.count
        _this.searchPriceTotal = res.sum_count
        _this.searchUserTotal = res.user_count
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.overview-total{
  width: 80%;
  display: flex;
  margin-bottom: 30px;
  .overview-box{
    width: 250px;
    border: 1px solid #989595;
    line-height: 33px;
    text-align: center;
    padding: 30px 0;
    flex: 1;
    margin: 5px 20px;
  }
  .tips{
    color: #b3b2b2;
  }
  .number{
    color: #e81616;
    font-size: 20px;
  }
}
.overview-line{
  .new-count-increase{
    color: #D53A35;
    padding: 0 10px;
  }
  .new-price-increase{
    color: #334B5C;
    padding: 0 10px;
  }
  .new-user-increase{
    color: #6AB0B8;
    padding: 0 10px;
  }
}
.echarts{
  width: 1000px;
  height: 400px;
}
</style>
